import {
  isPending,
  extractJsonFromBase64,
  CognitoUser,
  appAuthenticator,
  Logger,
  APIClients,
  ApiClientType,
  IntegrationsAPIClient
} from '@futrli/shared-services';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { resetError } from '../../core/redux-utils/actions';
import { StoreState } from '../../core/types';
import { Storage } from '../../storage/storage';
import { FORGOT_PASSWORD_SUBMIT } from '../constants';
import { getErrorSelector } from '../../core/redux-utils/selectors';
import { signIn, signInStarter } from '../../login/redux-utils/actions';
import { ForgotPasswordSubmitForm } from './forgot-password-submit-form';
import { MfaForm } from '../../login/components/mfa-form';

/**
 * Forgot password user submit.
 */
const ForgotPasswordSubmitFC: React.FC = () => {
  const [starterLoading, setStarterLoading] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState<CognitoUser | null>(null);
  const [showMfaForm, setShowMfaForm] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: StoreState) => isPending(state.loadingRequests.FORGOT_PASSWORD_SUBMIT));
  const error = useSelector((state: StoreState) => getErrorSelector(state.authReducers, FORGOT_PASSWORD_SUBMIT.ACTION));
  const { code, user: tempUser } = useParams();
  const resetPasswordCode = code || '';
  const userBase64 = tempUser || '';
  const user = extractJsonFromBase64(userBase64);
  const username = user.username || Storage.getInstance().get('username', '');

  const handleNewSubmit = async (password: string) => {
    if (!password) {
      return;
    }

    try {
      setStarterLoading(true);

      await appAuthenticator.forgotPasswordSubmit(username, resetPasswordCode, password);
      const { user, isMfa } = await signInStarter(username, password);
      if (isMfa) {
        setShowMfaForm(true);
        setLoggedInUser(user);
      } else {
        dispatch(signIn(navigate, username, password));
      }
    } catch (e) {
      Logger.error(e as string);
    } finally {
      setStarterLoading(false);
    }
  };

  React.useEffect(() => {
    APIClients.setApiClient(ApiClientType.Aws);
    IntegrationsAPIClient.setApiClient(ApiClientType.Aws);
    return () => {
      dispatch(resetError(FORGOT_PASSWORD_SUBMIT));
    };
  }, [dispatch]);

  if (showMfaForm) {
    return <MfaForm loggedInUser={loggedInUser} />;
  }

  return (
    <ForgotPasswordSubmitForm
      isLoading={isLoading || starterLoading}
      forgotPasswordSubmitError={error}
      onSubmit={handleNewSubmit}
    />
  );
};
export const ForgotPasswordSubmit = React.memo(ForgotPasswordSubmitFC);
